export default __webpack_public_path__ + "static/media/Go4-Logo-Red.12356b7c.svg";